import React from 'react';

function Customer() {
    return <h2>Customer</h2>;
}

export default Customer;